import React, { useState } from "react";
// import Bandhan_logo from "../assets/icons/Bandhan_logo.png";
import Bandhan_name_logo from "../assets/Images/Bandhan2.0-logo.svg";
import axis_maxlife_log from "../assets/Images/logo-patch-axismax.svg";
// import axis_maxlife_card from "../assets/Images/welcomeboard-image.png";
import facebook from "../assets/icons/facebook.svg";
import instagram from "../assets/icons/instagram.svg";
import twitterNew from "../assets/icons/twitterNew.svg";
import linkedin from "../assets/icons/linkedin.svg";
import { NavLink, useNavigate } from "react-router-dom";
// import { Box, Collapse, IconButton, Typography } from "@mui/material";
import "../LandingPage/Navbar.css";

import "./LandingPage.css";
const LandingPage = () => {
  const navigate = useNavigate();
  const [showIframe, setShowIframe] = useState(false);

  return (
    <>
      {!showIframe ? (
        <div className="Bandhan-landing-page-container">
          <header className="header">
            <div className="container">
              <img
                onClick={() => {
                  navigate("/");
                }}
                className="logo"
                src={Bandhan_name_logo}
                alt="logo"
              />

              <input className="menu-btn" type="checkbox" id="menu-btn" />
              <label className="menu-icon" htmlFor="menu-btn">
                <span className="navicon"></span>
              </label>
              <ul className="menu">
                <li>
                  <NavLink to="/helpfaqs" className="active">
                    Help & FAQs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/aboutbandhan">About Bandhan</NavLink>
                </li>

                <li>
                  <button
                    onClick={() => setShowIframe(true)}
                    className="start-now-buttons"
                  >
                    Start Now
                  </button>
                </li>
              </ul>
            </div>
          </header>

          <div className="Bandhan-data-card">
            <img
              className="Bandhan-data-card-image"
              src={axis_maxlife_log}
              alt="logo"
            />
            <h1 className="welcome-heading">Welcome To Bandhan 2.0</h1>

            <h1 className="welcome-heading2">
              Welcome To <br /> Bandhan 2.0
            </h1>

            <h2 className="paragraph-text">
              Your Digital Onboarding Module.
              <br /> We're excited to have you on board!
            </h2>
            <p className="note-paragraph-text2">
              (Please note: Completing the onboarding module and downloading the certificate of completion are mandatory to get started with your new role)
            </p>
            <button
              onClick={() => setShowIframe(true)}
              className="start-now-button"
            >
              {" "}
              Start Now
            </button>
            <button
              onClick={() => setShowIframe(true)}
              className="start-now-button1"
            >
              {" "}
              Start Now
            </button>

            <p className="note-paragraph-text">
              (Please note: Completing the onboarding module and downloading the certificate of completion are mandatory to get started with your new role)
            </p>
          </div>

          <div className="Bandhan-landing-page-logo-container">
            <a
              href="https://x.com/AxisMaxLifeIns"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={twitterNew} alt="logo" />
            </a>

            <a
              href=" https://facebook.com/AxisMaxLife/"
              target="_blank"
              rel="noopener"
            >
              <img className="icons-alignment" src={facebook} alt="logo" />
            </a>
            <a
              href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={instagram} alt="logo" />
            </a>

            <a
              href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={linkedin} alt="logo" />
            </a>
          </div>
          <footer className="section bg-footer">
            <div className="footer-section-icons">
              <a
                href="https://x.com/AxisMaxLifeIns"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="footer-icons-alignment"
                  src={twitterNew}
                  alt="logo"
                />
              </a>

              <a
                href=" https://facebook.com/AxisMaxLife/"
                target="_blank"
                rel="noopener"
              >
                <img
                  className="footer-icons-alignment"
                  src={facebook}
                  alt="logo"
                />
              </a>
              <a
                href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="footer-icons-alignment"
                  src={instagram}
                  alt="logo"
                />
              </a>

              <a
                href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
                target="_blank"
                rel="noopener"
              >
                <img
                  className="footer-icons-alignment"
                  src={linkedin}
                  alt="logo"
                />
              </a>
            </div>
          </footer>
        </div>
      ) : (
        <iframe
          title="Bandhan 2.0"
          width="100%"
          height="100%"
          id=""
          src="https://maxlife.gmetri.com/bandhan2"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; microphone; camera; display-capture; xr-spatial-tracking; xr;"
          frameborder="0"
          allowfullscreen
        ></iframe>
      )}
    </>
  );
};

export default LandingPage;
